<div id="showcase">

    <!-- ── CAROUSEL ─────────────────────────── -->
    <div id="showcaseCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
            <button type="button" data-bs-target="#showcaseCarousel" *ngFor="let slide of slider, let i = index"
                class="{{ (i == 0) ? 'active' : '' }}" attr.data-bs-slide-to="{{i}}" aria-current="true"
                [attr.aria-label]="'Slide ' + (i+1)">
            </button>
        </div>

        <div class="carousel-inner">
            <div class="carousel-item" *ngFor="let slide of slider, let i=index" [ngClass]="(i == 0) ? 'active' : ''">
                <div class="container-fluid d-flex justify-content-center align-items-center" id="loader"
                    *ngIf="isLoading[i]">
                </div>
                <img [src]="slide.imgUrl" alt="Slider" class="img-fluid w-100"
                    [ngStyle]="{visibility: isLoading[i] ? 'hidden' : 'visible'}" (load)="hideLoader(i)"
                    (error)="hideLoader(i)">

                <div class="slide-gradient-panel"></div>

                <div class="slide-content" *ngIf="!isLoading[i]">
                    <div class="slide-badge">
                        <i class="fa fa-award"></i>&nbsp; Vaish Girls College &nbsp;|&nbsp; Samalkha
                    </div>
                    <h1 class="slide-heading">
                        Empowering Women<br>
                        <span class="slide-heading-accent">Through Excellence</span><br>
                        in Education
                    </h1>
                    <p class="slide-desc">
                        Vaish Girls College, Samalkha (Panipat) — a premier institution dedicated to
                        the holistic development of women through academic excellence, character building,
                        and community leadership.
                    </p>
                    <!-- <div class="slide-actions">
            <a routerLink="/admissions/registration" class="slide-btn-primary">
              <i class="fa fa-pen-to-square"></i> Apply Now 2026–27
            </a>
            <a routerLink="/about-us" class="slide-btn-outline">
              <i class="fa fa-circle-play"></i> Explore More
            </a>
          </div>
          <div class="slide-courses">
            <span>B.A.</span><span>B.Sc.</span><span>B.Com</span><span>M.A.</span><span>BCA</span>
          </div> -->
                </div>
            </div>
        </div>

        <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>

</div>